import { styled } from '@mui/material';

export const Types = styled('div')`
  display: flex;
  gap: 8px;
`;
